import {DateTime, Duration} from "luxon";
import {computed} from "vue";
import {useRoute, useRouter} from "vue-router";

export default {
    path: function(path, ...args) {
        let endpoint = path;
        let index = 0;
        while (endpoint.includes("@") && args.length > index) {
            endpoint = endpoint.replace("@", args[index]);
            index++;
        }
        return endpoint;
    },
    decodeValidationErrors: function(errors) {
        let newErrors = {};
        for (const [key, value] of Object.entries(errors)) {
            this.setObjectItem(newErrors, key, value)
        }
        return newErrors;
    },
    parseISODate(date) {
        return DateTime.fromISO(date, { zone: "utc" }).setZone("local");
    },
    formatDate: function(date) {
        return DateTime.fromISO(date, { zone: "utc" }).setZone("local").toLocaleString(DateTime.DATE_MED);
    },
    formatDatetime: function(date) {
        return DateTime.fromISO(date, { zone: "utc" }).setZone("local").toLocaleString(DateTime.DATETIME_MED_WITH_SECONDS);
    },
    formatDuration: function(seconds, short) {
        const normalized = Duration.fromObject({ days: 0, hours: 0, minutes: 0, seconds: seconds }).normalize();
        const newValue = {};
        if (normalized.days > 0) newValue.days = normalized.days;
        if (normalized.hours > 0) newValue.hours = normalized.hours;
        if (normalized.minutes > 0) newValue.minutes = normalized.minutes;
        if (normalized.seconds > 0) newValue.seconds = normalized.seconds;
        return Duration.fromObject(newValue).toHuman({ unitDisplay: short ? "short" : "long" });
    },
    getObjectItem: function(container, path) {
        if (container === undefined || container === null) return undefined;
        let keys = path.split(".");
        let item = container;
        for (let i = 0; i < keys.length; i++) {
            let key = keys[i];
            if (item !== undefined && item !== null) {
                item = item[key];
            } else {
                item = undefined;
                break;
            }
        }
        return item;
    },
    setObjectItem: function(container, path, value) {
        if (container === undefined || container === null) return undefined;
        if (path === undefined || path === null) {
            container = value;
            return container;
        }
        let keys = path.split(".");
        if (keys.length !== 1) {
            let item = container
            for (let i = 0; i < keys.length - 1; i++) {
                let key = keys[i];
                if (item[key] === undefined || item[key] === null) {
                    item[key] = {};
                }
                item = item[key];
            }
            item[keys[keys.length - 1]] = value;
            return container;
        }
        container[keys[0]] = value;
        return container;
    },
    routeQueryParam: (name) => {
        const route = useRoute();
        const router = useRouter();
        return computed({
            get: () => route.query[name],
            set: value => {
                let query = JSON.parse(JSON.stringify(route.query));
                query[name] = value;
                router.push({ name: route.name, params: route.params, query: query });
            }
        });
    },
    routePathParam: (name) => {
        const route = useRoute();
        const router = useRouter();
        return computed({
            get: () => route.params[name],
            set: value => {
                let params = JSON.parse(JSON.stringify(route.params));
                params[name] = value;
                router.push({ name: route.name, params: params, query: route.query });
            }
        });
    },
    slugify: value => {
        return value?.toLowerCase().trim().replace(/ /g, "-").replace(/[^a-z\-0-9]/g, "").replace(/(\-)\-*/g, "$1");
    }
};